import React from 'react';

import { defaultUserState } from './User';

const AuthContext = React.createContext({
  userState: defaultUserState,
});

export default AuthContext;
